<template>

    <section class="w-100 h-100">

        <!-- Loading -->
        <loading/>

        <!---Media List-->
        <div class="d-flex flex-column" id="header_media">

            <!---Title Page-->
            <div class="order-1 d-flex flex-column">
                <div class="d-flex flex-row justify-content-between order-1">
                    <h1 class="order-1">Media Manager</h1>
                    <button @click="showModal($event, 'insertmedia')" type="button" class="btn btn-primary order-2">Add Image</button>
                </div>
                <small class="order-2 my-2">Show menu when right-clicking image</small>
            </div>
        
            <!---Show all Medias-->
            <div class="d-flex flex-column justify-content-center align-item-center p-3 order-2">

                <div v-if="Object.values(alldata).length > 0" class="order-1 d-flex flex-column">

                    <!--Add Display Grid-->
                    <div class="order-1 d-flex flex-row" style="flex-wrap:wrap;">

                        <!---Media Unity-->
                        <figure v-for="(value, index) in alldata" 
                            :key="value.id" 
                            style="width:20rem;height:25rem;margin-right:1rem;padding:1rem;"
                            class="cardselectimg mb-3 d-flex flex-column align-items-center justify-content-center p-0"
                            @contextmenu.prevent="showSubMenu($event)"
                        >

                            <img 
                                :src="value.filelink" 
                                :alt="value.filealt"
                                :data-filealt="value.filealt"
                                :data-fileext="value.fileext"
                                :data-filenamenew="value.filenamenew"
                                :data-filenameold="value.filenameold"
                                :data-fileid="value.id"
                                :data-referid="index"
                                class="media-image"
                                style="width:inherit;height:100%;object-fit:fill;"
                                />

                            <figcaption class="mb-3 d-flex flex-column justify-content-center align-items-center w-100">
                                    <p class="order-1">Filename: {{ resumeMessage(value.filenameold, 20, 2) }}</p>
                                    <p class="order-2">Location: {{ resumeMessage(value.filelocation, 20, 2) }}</p>
                            </figcaption>

                            <!---Submenu Content-->
                            <div class="submenumedia d-none flex-row justify-content-between w-100">

                                <button 
                                    class="btn btn-primary mb-2 order-1" 
                                    type="button" 
                                    :data-referid="index" 
                                    :data-mediaid="value.id"
                                    :data-filealt="value.filealt"
                                    :data-filenameold="value.filenameold"
                                    :data-fileext="value.fileext"
                                    data-mediatype="image" 
                                    aria-describedby="Edit Image"
                                    @click="showModal($event, 'updatemedia')"
                                >Edit</button>
                                <button 
                                    class="btn btn-danger mb-2 order-2" 
                                    type="button" 
                                    :data-referid="index" 
                                    :data-mediaid="value.id"
                                    data-mediatype="image"
                                    :data-filenamenew="value.filenamenew" 
                                    aria-describedby="Remove Image"
                                    @click="removeAction($event)"
                                >Remove</button>

                            </div>

                        </figure>

                    </div>

                </div>

                <span v-else>Ainda não possui ficheiros</span>

            </div>

        </div>

        <!-- Back To Top -->
        <back-to-top 
            idhref="header_media"
        />

        <!--Modal Update--->
        <modal
            title="Edit Media"
            classname="updatemedia"
        >

            <template #modalcontent>

                <form @submit.prevent="sendData('update')" action="" class="updatemediadata"  method="post" aria-describedby="Update Media" enctype="application/x-www-form-urlencoded" autocomplete="on">

                    <div class="mb-3">
                        <label for="filealt" class="form-label">File Alt</label>
                        <input type="text" v-model="filealt" class="form-control" id="filealt" aria-describedby="File Alt">
                    </div>

                    <div class="mb-3">
                        <label for="filename" class="form-label">File Name</label>
                        <input type="text" v-model="filename" class="form-control" id="filename" aria-describedby="File Name">
                    </div>
                 
                    <button type="submit" class="btn btn-primary" :disabled="disabled">Update</button>

                </form>

            </template>

        </modal>

        <!--Modal Insert--->
        <modal
            title="Insert Media"
            classname="insertmedia"
        >

            <template #modalcontent>

                <form @submit.prevent="sendData('insert', filedataformlist)" action="" class="insertmediadata"  method="post" aria-describedby="Create Media" enctype="multipart/form-data" autocomplete="on">

                    <div class="mb-3">
                        <label for="filealt" class="form-label">File Alt</label>
                        <input type="text" v-model="filealt" class="form-control" id="filealt" aria-describedby="File Alt">
                    </div>

                    <div class="mb-3">
                        <label for="file" class="form-label">File</label>
                        <input @change="multipleFileData($event)" class="form-control files" name="files" type="file" id="files" accept="image/*" ref="inputfile">
                    </div>
                 
                    <button type="submit" class="btn btn-primary">Submit</button>

                </form>

            </template>

        </modal>

        <!-- Response Messages -->
        <div class="order-3 responsebasemessage" ref="responsebasemessage">

            <list-message/>

        </div>

    </section>    

</template>
<script>

    import fetchData from './../../fetchData.js';
    import validation from './../../inputValidation.js';
    import Modal from './../elements/ModalElement.vue';
    import ListMessage from './../elements/ListMessageElement.vue';
    import Loading from './../elements/LoadingElement.vue';
    import BackToTop from './../elements/BackToTopElement.vue';

    //Set Use Strict
    "use strict";

    export default{
        name: 'MediaComponent',
        props:{

            csrftolken:{
                type: String,
                required: true
            },
            allmedia:{
                type: String,
                required: true
            },
            mediaupdate:{
                type: String,
                required: true
            },
            mediadelete:{
                type: String,
                required: true
            },
            mediainsert:{
                type: String,
                required: true
            }

        },
        data: () => {

            return {

                disabled: false,
                alldata: {},
                activeclass: 'd-flex',
                filename: '',
                filealt: '',
                fileindex: '',
                filemediaid: '',
                filetype: '',
                filedataupdate: {},
                filenamenew: '',
                alertgigabyte: 1024 * 1024 * 1000 * 2,
                filedataformlist: [],
                filedataformitemlist: {},
                filewidthheightlist: [],
                alertmegabyte: 1024 * 1000 * 1.5

            }

        },
        created(){

            //Set all medias
            this.alldata = JSON.parse(this.allmedia);

        },
        methods:{

            resumeMessage(text, limit, divisor){

                //console.log(text);
                if(text !== undefined){

                    let resume = text.length > limit ?
                    `${text.substr(0, Math.round(text.length / divisor))}...` : text;

                    return resume;

                }

            },
            showSubMenu(element){

                //Check Parent
                let submenu = element.target.nodeName === 'IMG' ? element.target.nextElementSibling.nextElementSibling : element.target.parentElement.nextElementSibling;
                
                //List All Submenu divs
                let submenuDivList = [...document.querySelectorAll('.submenumedia')];

                //Check All Submenu divs
                submenuDivList.forEach((value) => {

                    if(submenu !== value){

                        value.classList.add('d-none');
                        value.classList.remove('d-flex');

                    }else{

                        //Show Submenu Conditional
                        value.classList.remove('d-none');
                        value.classList.add('d-flex');

                    }

                });

            },
            showModal(element, classname){

                //Clean Variable
                this.filealt = '';

                //Check Action
                if(classname === 'updatemedia'){

                    //Set Filedata
                    this.filetype = element.target.getAttribute('data-mediatype');
                    this.fileindex = element.target.getAttribute('data-referid');
                    this.filemediaid = element.target.getAttribute('data-mediaid');
                    this.filealt = element.target.getAttribute('data-filealt');
                    this.filename = element.target.getAttribute('data-filenameold').replace(element.target.getAttribute('data-fileext'), '');

                }

                //Show Modal
                $(`.${classname}`).modal("show");

                return;

            },
            hideModal(classname){

                //Hide Modal
                $(`.${classname}`).modal("hide");

                return;

            },
            removeAction(element){

                //Set Filedata
                this.filetype = element.target.getAttribute('data-mediatype');
                this.filemediaid = element.target.getAttribute('data-mediaid');
                this.filenamenew = element.target.getAttribute('data-filenamenew');

                //Set an Object
                this.filedataupdate = {
                    mediatype: this.filetype,
                    id: this.filemediaid,
                    filenamenew: this.filenamenew
                };

                return this.sendData('delete', this.filedataupdate);

            },
            dataStructureResponse(responseObject){

                //Get Key and Value
                let entries = Object.entries(responseObject);

                //Response Value

                //Loop response conditional
                for(const [key, value] of entries){

                    switch(key)
                    {

                        case 'attListData':

                            //Set Data
                            this.alldata = JSON.parse(value);

                        break;

                        case 'attListDataMedia':

                            //Set Data
                            let mediaData = JSON.parse(value);

                            //Remove LocalStorage
                            localStorage.removeItem('medialist');

                            //Set New Values for Media List
                            localStorage.setItem('medialist', JSON.stringify(mediaData));

                        break;

                        case 'attListDataLogotipoMedia':

                            //Set Data
                            let logotipoData = JSON.parse(value);

                            //Remove LocalStorage
                            localStorage.removeItem('logotipolist');

                            //Set New Values for Media List
                            localStorage.setItem('logotipolist', JSON.stringify(logotipoData));

                        break;

                        case 'successMessage':
                        case 'errorMessage':
                            
                            //Add active Class
                            this.$refs.responsebasemessage.classList.add(this.activeclass);
                            this.$refs.responsebasemessage.classList.add(key.toLowerCase());

                            //Set Messages List
                            value.forEach((valmessage) => {

                                //Element for append
                                let li = `<li class="list-group item my-1">${valmessage}</li>`;

                                //Append Element
                                $(li).appendTo(this.$refs.responsebasemessage.children);

                            });
                            
                        break;

                    }

                }

                //Clean Data
                this.filename = '';
                this.filealt = '';
                this.fileindex = '';
                this.filemediaid = '';
                this.filetype = '';
                this.filedataupdate = {};
                this.filenamenew = '';

                //Clean Variable from file action
                this.filedataformitemlist = {};
                this.filedataformlist = [];
                this.filewidthheightlist = [];

                //Remove disabled from files
                document.querySelector('.files').removeAttribute('disabled');

                //Clean values from files
                document.querySelector('.files').value = "";

                //Close Modal
                this.hideModal('updatemedia');
                this.hideModal('insertmedia');

                //Enable BTN
                this.disabled = false;

                //Remove Base Response Message
                this.removeResponseMessages();

                return;

            },
            removeResponseMessages(time = 5000){

                setTimeout(function(){

                    //Remove active class
                    document.querySelector('.responsebasemessage').classList.remove('d-flex');
                    document.querySelector('.responsebasemessage').classList.remove('successmessage');
                    document.querySelector('.responsebasemessage').classList.remove('errormessage');

                    //Remove children elements
                    let ul = document.querySelector('.responsebasemessage').children;

                    [...ul[0].children].forEach((valli) => {

                        //Remove Elements
                        valli.remove();

                    });

                }, time);

            },
            multipleFileData(element){

                //Set Disabled
                element.target.setAttribute('disabled', true);

                //FileData Item Object Clean Variable
                this.filedataformitemlist = {};

                //Get Data from File
                let filedata = element.target.files;

                //Get Data from Multiple File
                [...filedata].forEach((value, index) => {

                    //Check fileSize
                    if(value.size >= Math.abs(this.alertmegabyte)){

                        alert('Please upload a smaller file up to 1MG');

                        //Enabled Input
                        element.target.removeAttribute('disabled');

                        //Disabled Submit button
                        this.disabled = true;

                        return;

                    }

                    //Check type of the file
                    if(!value.type.includes('image')){

                        alert('Please only send image type file');

                        //Disabled Submit button
                        this.disabled = true;

                        return;

                    }

                    //Structure File Data Object
                    this.filedataformitemlist = {
                        fileindex: index,
                        filename: value.name.trim(),
                        filedata: {}
                    };

                    //Get Width and Height from Image
                    let reader = new FileReader();
                        reader.readAsDataURL(value);
                        reader.onload = e => {

                            const src = e.target.result;

                            const img = new Image();

                            img.onload = () => {

                                //Set FileDimension
                                let filedimension = {
                                    width: img.width,
                                    height: img.height
                                };

                                //Set File width and height
                                this.filewidthheightlist.push(filedimension);

                                return this.filewidthheightlist; 

                            };

                            img.onerror = (error) => {
                                
                                throw new Error(error)

                            };

                            img.src = src;

                        }; 

                    //Get base64 Promise
                    let file64Promise = fetchData.toBase64(value);

                    //Get Data from Promise
                    file64Promise.then((val64) => {

                        //Check File Alt
                        let filealtname = this.filealt ? this.filealt : value.name.trim().replace(value.type.replace("image/", ""), '').toLowerCase();

                        //Structure File Data Object
                        this.filedataformitemlist.filedata = {
                            type: value.type.replace("image/", ""),
                            filealt: filealtname.trim(),
                            file64: val64,
                            filealldimensions: this.filewidthheightlist[index] ? this.filewidthheightlist[index] : null
                        };

                        //Push Data
                        this.filedataformlist.push(this.filedataformitemlist);

                        //Send Data for Storage File
                        return this.filedataformlist;

                    }).catch((error) => {

                        throw new Error(error);

                    });

                });

            },
            sendData(formaction, data = null, element = null){

                //Disabled BTN
                this.disabled = true;

                //Active Loading
                document.querySelector('.loadingbase').classList.add('d-flex');

                //Structure Data Form
                let dataForm = {};

                //Set Route
                let method;
                let urlmethod; 

                switch(formaction)
                {
                    //Insert
                    case 'insert':

                        method = 'POST';
                        urlmethod = this.mediainsert;

                        //Set DataForm
                        dataForm.action = formaction;
                        dataForm.data = data;

                        //Check Data for insert route
                        if(dataForm.data.length === 0){

                            //Send Message
                            alert('Por favor apenas enviar dados válidos');

                            //Desactive Loading
                            document.querySelector('.loadingbase').classList.remove('d-flex');

                            //Enableds BTN
                            this.disabled = false;

                            return;

                        }

                    break;

                    //Update
                    case 'update':

                        method = 'PUT';
                        urlmethod = this.mediaupdate;

                        //Get Data for update Media
                        let alldata = this.alldata;
                        let filedataupdate = alldata.find((value, index) => index === parseInt(this.fileindex));

                        //Check Data for insert route
                        if(filedataupdate === undefined){

                            //Send Message
                            alert('Por favor apenas enviar dados válidos');

                            //Desactive Loading
                            document.querySelector('.loadingbase').classList.remove('d-flex');

                            //Enableds BTN
                            this.disabled = false;

                            return;

                        }

                        //Remove Desenecessary object
                        delete filedataupdate.created_at;
                        delete filedataupdate.updated_at;
                        delete filedataupdate.filelink;
                        delete filedataupdate.filelocation;
                        delete filedataupdate.id;

                        //Set update data
                        filedataupdate.filealt = this.filealt ? this.filealt.trim() : filedataupdate.filealt;
                        filedataupdate.filenameold = this.filename ? this.filename.trim() + filedataupdate.fileext : filedataupdate.filenameold;

                        //Set DataForm
                        dataForm.id = this.filemediaid;
                        dataForm.data = filedataupdate;
                        dataForm.mediatype = this.filetype;
                        dataForm.action = formaction;

                    break;

                    //Delete
                    case 'delete':

                        method = 'DELETE';
                        urlmethod = this.mediadelete;
                        dataForm = data;
                        dataForm.action = formaction;

                    break;

                }

                //console.log([method, urlmethod]);
                //console.log(Object.keys(dataForm));
                /* console.log(data);
                console.log(dataForm.data.length);
                return; */

                //Check Data Form
                if(Object.keys(dataForm).length > 0){

                    //Send Data
                    let response = fetchData.structureTosendData(urlmethod, dataForm, this.csrftolken, method);

                    //Check Response
                    response.then((value) => {

                        //Desactive Loading
                        document.querySelector('.loadingbase').classList.remove('d-flex');

                        //Generate a Response
                        return this.dataStructureResponse(value);

                    }).catch((error) => {

                        alert('Ocorreu um erro ao executar sua requisição é necessário fazer o reload da Página');

                        //Desactive Loading
                        document.querySelector('.loadingbase').classList.remove('d-flex');

                        //Enableds BTN
                        this.disabled = false;

                        throw new Error(error);

                    });

                }else{

                    //Send Message
                    alert('Por favor apenas enviar dados válidos');

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Enableds BTN
                    this.disabled = false;

                }

                return;

            }

        },
        computed:{

            computedAllData(){

                return this.alldata;

            },
            computedFileIndex(){

                return this.fileindex;

            },
            computedFileUpdate(){

                return this.filedataupdate;

            },
            computedFileAlt(){

                return this.filealt;

            },
            computedFileName(){

                return this.filename;

            },
            computedFileType(){

                return this.filetype;

            },
            computedFilenamenew(){

                return this.filenamenew;

            },
            computedFiledataFormList(){

                return this.filedataformlist;

            },
            computedFileFormItemList(){

                return this.filedataformitemlist;

            },
            computedFileWidthHeightList(){

                return this.filewidthheightlist;

            }

        },
        watch:{

            computedAllData(){},
            computedFileIndex(){},
            computedFileUpdate(){},
            computedFileAlt(){},
            computedFileName(){},
            computedFileType(){},
            computedFilenamenew(){},
            computedFiledataFormList(){},
            computedFileFormItemList(){},
            computedFileWidthHeightList(){}
       
        },
        components:{

            listMessage: ListMessage,
            loading: Loading,
            modal: Modal,
            backToTop: BackToTop,

        }


    }

</script>